module.exports = __webpack_public_path__ + "img/sale-badge-2.f19c3a76.png";